/* RESPONSIBLE TEAM: team-messenger */
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { LIGHT_THEME_TYPE, DARK_THEME_TYPE } from 'embercom/lib/messenger-settings/target-types';

type TargetThemeType = typeof LIGHT_THEME_TYPE | typeof DARK_THEME_TYPE;

export default class MessengerSettingsThemeProvider extends Service {
  @tracked targetThemeType: TargetThemeType = LIGHT_THEME_TYPE;

  get isLightTheme() {
    return this.targetThemeType === LIGHT_THEME_TYPE;
  }

  get isDarkTheme() {
    return this.targetThemeType === DARK_THEME_TYPE;
  }

  setLightTheme() {
    this.targetThemeType = LIGHT_THEME_TYPE;
  }

  setDarkTheme() {
    this.targetThemeType = DARK_THEME_TYPE;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'messenger-settings-theme-provider': MessengerSettingsThemeProvider;
  }
}
